import { ERROR as COLOR_ERROR, SUCCESS as COLOR_SUCCESS, WARNING as COLOR_WARNING } from '../styles/colors';

export enum InputState {
	NORMAL,
	SUCCESS,
	WARNING,
	ERROR,
}

export function getColorForInputState(inputState: InputState) {
	switch (inputState) {
		case InputState.SUCCESS:
			return COLOR_SUCCESS;
		case InputState.WARNING:
			return COLOR_WARNING;
		case InputState.ERROR:
			return COLOR_ERROR;
		case InputState.NORMAL:
		default:
			return 'transparent';
	}
}
